import React, { Fragment } from "react";
import "./loading.scss";

const Loading = () => {
  return (
    <Fragment>
      <div className=" bg-blur" />
      <div className="loading">
        <div className="loader">
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--text"></div>
        </div>
      </div>
    </Fragment>
  );
};

export default Loading;
